<template>
  <v-container fluid>
    <v-slide-y-transition mode="out-in">
      <v-layout column class="elevation-4">
        <v-tabs centered v-model="activeTab">
          <v-tab>Find a Staff Member</v-tab>
          
        </v-tabs>
        <v-tabs-items v-model="activeTab">
          <v-tab-item>
            <staff-list></staff-list>
          </v-tab-item>
          
        </v-tabs-items>
      </v-layout>
    </v-slide-y-transition>
  </v-container>
</template>

<script>
import StaffList from "../components/StaffList.vue";

export default {
  name: "Staff",
  data() {
    return {
      activeTab: 0
    };
  },
  components: {
    "staff-list": StaffList
    //'students-by-class': StudentsByClass
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
